<template>
  <div class="panel" :style="{ background: contantBackground }">
    <Title :title="data.themeName" />
    <div class="body">
      <template v-for="item in data.themeBrandList">
        <Item :key="item.partId" :data="item" :coupons="data.coupons" />
      </template>
    </div>
  </div>
</template>

<script>
import Title from '../../Title'
import Item from './item'
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },

    contantBackground: {
      type: String,
      default: 'red',
    },
  },
  components: { Title, Item },
}
</script>

<style lang="less" scoped>
.panel {
  padding: 0 20px;
}
</style>
